var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-search-select',_vm._b({attrs:{"route":_vm.route,"option-label":"title","clearable":_vm.clearable,"load-all":""},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var itemProps = ref.itemProps;
var itemEvents = ref.itemEvents;
var opt = ref.opt;
var selected = ref.selected;
var toggleOption = ref.toggleOption;
return [_c('q-item',_vm._g(_vm._b({},'q-item',itemProps,false),itemEvents),[_c('q-item-section',[_c('q-item-label',[_vm._v(" "+_vm._s(opt.title)+" ")])],1)],1)]}}]),model:{value:(_vm.departmentIdValue),callback:function ($$v) {_vm.departmentIdValue=$$v},expression:"departmentIdValue"}},'entity-search-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }